/**
 * Back in stock — « Créer une alerte » (Klaviyo Back in Stock, client API).
 *
 * 1. Ouvre la popup (MinimogTheme.Modal) au clic sur [data-bis-trigger]
 *    (cartes collection, fiche produit, barre sticky). Délégation d'événement :
 *    fonctionne aussi après un rechargement AJAX de la grille (filtres, scroll infini).
 * 2. Envoie l'inscription à Klaviyo : POST /client/back-in-stock-subscriptions/
 * 3. Sur la fiche produit, synchronise l'état « épuisé » (bouton d'achat ↔ « Créer une alerte »)
 *    quand la variante change, y compris depuis la barre sticky.
 */
(function () {
  if (window.MinimogBackInStock) return;

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var KLAVIYO_REVISION = '2024-06-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var config = null;
  var modal = null;

  function readConfig() {
    if (config) return config;
    var node = document.getElementById('BackInStockConfig');
    if (!node) return null;
    try {
      config = JSON.parse(node.textContent);
    } catch (e) {
      config = null;
    }
    return config;
  }

  function parseVariants(trigger) {
    try {
      var list = JSON.parse(trigger.dataset.bisVariants || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setMessage(node, text, type) {
    if (!node) return;
    if (!text) {
      node.hidden = true;
      node.textContent = '';
      node.removeAttribute('data-type');
      return;
    }
    node.textContent = text;
    node.setAttribute('data-type', type || 'error');
    node.hidden = false;
  }

  function buildContent(trigger) {
    var template = document.getElementById('BackInStockTemplate');
    if (!template) return null;
    var cfg = readConfig() || { strings: {} };
    var strings = cfg.strings || {};

    var fragment = template.content.cloneNode(true);
    var root = fragment.querySelector('[data-bis-modal]');
    if (!root) return null;

    var productTitle = trigger.dataset.productTitle || '';
    var productImage = trigger.dataset.productImage || '';
    var variants = parseVariants(trigger);
    var targetVariantId = String(trigger.dataset.variantId || '');
    var hasOnlyDefaultVariant = trigger.dataset.hasOnlyDefaultVariant === 'true';

    var titleNode = root.querySelector('[data-bis-product-title]');
    if (titleNode) titleNode.textContent = productTitle;

    var imageNode = root.querySelector('[data-bis-image]');
    if (imageNode && productImage) {
      var img = document.createElement('img');
      img.src = productImage;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 72;
      img.height = 72;
      imageNode.appendChild(img);
      imageNode.hidden = false;
    }

    var variantField = root.querySelector('[data-bis-variant-field]');
    var select = root.querySelector('[data-bis-variant-select]');
    if (select && variants.length > 1 && !hasOnlyDefaultVariant) {
      variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.available && strings.variantAvailable
          ? variant.title + ' · ' + strings.variantAvailable
          : variant.title;
        if (String(variant.id) === targetVariantId) option.selected = true;
        select.appendChild(option);
      });
      if (variantField) variantField.hidden = false;
    } else if (select) {
      var single = document.createElement('option');
      single.value = targetVariantId || (variants[0] ? String(variants[0].id) : '');
      single.selected = true;
      select.appendChild(single);
    }

    var form = root.querySelector('[data-bis-form]');
    if (form) form.addEventListener('submit', onSubmit);

    var closeButton = root.querySelector('[data-bis-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        if (modal) modal.close();
      });
    }

    return root;
  }

  function openModal(trigger) {
    if (!window.MinimogTheme || typeof window.MinimogTheme.Modal !== 'function') return;
    var content = buildContent(trigger);
    if (!content) return;

    if (!modal) modal = new window.MinimogTheme.Modal();
    // Déjà ouverte (double-clic pendant la transition) : on ne rouvre pas
    if (modal.modal && modal.modal.isConnected) return;
    // Sécurité : aucun contenu résiduel d'une ouverture précédente
    if (modal.modalContentInner) modal.modalContentInner.replaceChildren();
    var wrapper = document.createElement('div');
    wrapper.appendChild(content);
    modal.appendChild(wrapper);
    modal.setWidth('460px');
    modal.setSizes('m-bis-modal');
    modal.open();

    setTimeout(function () {
      var email = content.querySelector('[data-bis-email]');
      if (email && window.matchMedia('(min-width: 768px)').matches) email.focus();
    }, 250);
  }

  function onSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var root = form.closest('[data-bis-modal]');
    var cfg = readConfig();
    var strings = (cfg && cfg.strings) || {};
    var messageNode = form.querySelector('[data-bis-message]');
    var emailInput = form.querySelector('[data-bis-email]');
    var select = form.querySelector('[data-bis-variant-select]');
    var submit = form.querySelector('[data-bis-submit]');
    var submitText = submit ? submit.querySelector('.m-bis__submit-text') : null;

    var email = emailInput ? emailInput.value.trim() : '';
    var variantId = select ? select.value : '';

    setMessage(messageNode, '');

    if (!EMAIL_RE.test(email)) {
      setMessage(messageNode, strings.invalidEmail || 'Invalid email', 'error');
      if (emailInput) emailInput.focus();
      return;
    }
    if (!cfg || !cfg.companyId || !variantId) {
      setMessage(messageNode, strings.error || 'Error', 'error');
      return;
    }

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    if (submit) submit.setAttribute('disabled', 'disabled');
    if (submitText && strings.submitting) submitText.textContent = strings.submitting;
    form.classList.add('is-loading');

    fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.ok) return null;
        return response
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
            throw new Error(detail || 'Request failed (' + response.status + ')');
          });
      })
      .then(function () {
        if (root) root.classList.add('is-success');
        var success = root ? root.querySelector('[data-bis-success]') : null;
        if (success) success.hidden = false;
        form.hidden = true;
        document.dispatchEvent(
          new CustomEvent('back-in-stock:subscribed', {
            detail: { email: email, variantId: variantId }
          })
        );
      })
      .catch(function (error) {
        if (window.console && console.warn) console.warn('[back-in-stock]', error);
        setMessage(messageNode, strings.error || 'Error', 'error');
      })
      .finally(function () {
        if (submit) submit.removeAttribute('disabled');
        if (submitText && strings.submit) submitText.textContent = strings.submit;
        form.classList.remove('is-loading');
      });
  }

  /* ---------- Ouverture : délégation sur tout le document ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var trigger = target && target.closest('[data-bis-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openModal(trigger);
  });

  /* ---------- Fiche produit : synchro « épuisé » quand la variante change ---------- */
  function syncProductPage(variant, sectionId) {
    // Uniquement le produit principal de la page (pas une section « produit en vedette »)
    var mainProduct = document.querySelector("product-info[id^='MainProduct']");
    if (!mainProduct) return;
    if (sectionId && mainProduct.dataset.sectionId !== sectionId) return;

    var soldOut = !!variant && variant.available === false;
    var variantId = variant ? String(variant.id) : '';

    // Barre sticky (le bouton principal est géré par product-info.js)
    document.querySelectorAll('.m-sticky-addtocart').forEach(function (bar) {
      bar.classList.toggle('is-sold-out', soldOut);
      bar.querySelectorAll('[data-bis-trigger]').forEach(function (trigger) {
        if (variantId) trigger.dataset.variantId = variantId;
      });
    });
  }

  function subscribeVariantChange() {
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return false;
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, function (event) {
      var data = (event && event.data) || {};
      syncProductPage(data.variant, data.sectionId);
    });
    return true;
  }

  if (!subscribeVariantChange()) {
    window.addEventListener('load', subscribeVariantChange);
  }

  window.MinimogBackInStock = { open: openModal };
})();
